import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Active = ({ size, color, theme, iconTitle }) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      color={iconColor}
      fill={iconColor}
    >
      <title>{iconTitle}</title>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Circle" fill="#A28352" cx="7" cy="7" r="7"></circle>
        <polyline
          stroke="#FFFFFF"
          stroke-width="2"
          points="4 7.71934024 6.44247269 10 11 4"
        ></polyline>
      </g>
    </svg>
  );
};

Active.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Active.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Active);
